import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { CreateCrmIntegration, CrmIntegration } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export const createCrmIntegration = async (
  params: CreateCrmIntegration
): Promise<CrmIntegration> => {
  return await tinctApi.crmIntegrations.createCrmIntegration(params);
};

export const useCreateCrmIntegration = (
  options?: Omit<
    UseMutationOptions<CrmIntegration, ApiError, CreateCrmIntegration>,
    'mutationFn'
  >
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCrmIntegration,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['crm-integrations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['organization', args[1].organizationId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
